/*
 * @Autor: suhang
 * @Date: 2022-05-17 15:42:30
 * @LastEditors: suhang
 * @LastEditTime: 2022-05-18 14:23:20
 * @Description:
 */

import Vue from 'vue'
import { createRouter, createWebHistory, RouteRecordRaw } from "vue-router"
import { notFoundRoutes } from "./module/notFoundRoutes"
import {i18n} from '../i18n'
const Index = () => import("../views/index/Index.vue")
const QuanZi = () => import("../views/index/quanzi.vue")
const DriveBooking = () => import(/* webpackChunkName: "purchase" */ "@/views/purchase/DriveBooking")
const MyActivitiesDetail = () => import("../views/my/myActivitiesDetail.vue")



const routes = [
  { path: '/', redirect: '/index' },
  {
      path: "/404",
      name: "404",
      component: () =>
          import(
              /* webpackChunkName: "404" */ "@/views/404"
          ),
	  meta: {
	  		title: "页面不存在"
	    }
  },
  {
      path: "/:pathMatch(.*)*",
      redirect: "/404"
  },
  {
    path: '/index',
    name: 'index',
    component: Index,
	meta: {
			title: "茵末"
	  },
    children: [
		{ path: '', component: QuanZi }, 
		{
		  path: '/quanzi',
		  name: 'quanzi',
		  component: QuanZi,
			meta: {
			    title: "茵末h5"
			}
		}, 
		{
		  path: '/drive-booking',
		  name: 'drive-booking',
		  component: DriveBooking,
		  meta: {
			    title: "预约试驾"
		    }
		}, 
		{
		  path: '/myActivitiesDetail', name: 'myActivitiesDetail', component: MyActivitiesDetail,
		  meta: {
		  		title: "详情页"
		    }
		},
		
    ]
  }
]

// 404页面路由，必须最后添加
// notFoundRoutes.map((item) => router.addRoute(item))

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
})

router.afterEach((to, from, next) => {
    if (to.meta.title) {
        document.title = to.meta.title as string
    }
})

export default router

